// AppFolioRefreshControl — "Refresh from AppFolio" beside the builder's
// property/unit line (WEL-169), plus the quiet note or plain error it leaves.
// Presentational only (state from hooks/useAppFolioRefresh). Staff copy; no ids.

export function AppFolioRefreshControl({
  busy,
  note,
  error,
  onRefresh,
  disabled = false,
}: {
  busy: boolean;
  note: string | null;
  error: string | null;
  onRefresh: () => void;
  disabled?: boolean;
}): React.JSX.Element {
  return (
    <div
      data-section="appfolio-refresh"
      style={{
        display: 'flex',
        alignItems: 'center',
        flexWrap: 'wrap',
        gap: 'var(--space-2)',
        marginTop: 'var(--space-2)',
        fontSize: 'var(--text-xs)',
      }}
    >
      <button
        type="button"
        className="btn"
        data-variant="secondary"
        data-size="sm"
        onClick={onRefresh}
        disabled={busy || disabled}
        aria-busy={busy || undefined}
        title="Pull this property’s latest details from AppFolio — use it right after fixing a field there."
      >
        {busy ? (
          <>
            <span className="dot" data-tone="info" data-pulse="true" aria-hidden="true" />
            Refreshing…
          </>
        ) : (
          'Refresh from AppFolio'
        )}
      </button>
      {!busy && error ? (
        <span className="text-danger" role="status">
          {error}
        </span>
      ) : !busy && note ? (
        <span style={{ color: 'var(--fg-muted)' }} role="status">
          {note}
        </span>
      ) : null}
    </div>
  );
}
